import { render, staticRenderFns } from "./CCEventModal.vue?vue&type=template&id=bf4ac6ea&scoped=true&"
import script from "./CCEventModal.vue?vue&type=script&lang=ts&"
export * from "./CCEventModal.vue?vue&type=script&lang=ts&"
import style0 from "./CCEventModal.vue?vue&type=style&index=0&id=bf4ac6ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4ac6ea",
  null
  
)

export default component.exports